import React from 'react';
import { Input, Select, Button, TableContainer, FieldSet, FormGroup, Checkbox, Validator as V } from 'hrone-react';
import { observer } from 'mobx-react';
import './index.less';
import mainStore from '../main.store';
import store from './index.store';

@observer
export default class Organization extends React.PureComponent {
    state = {
        protocolCheck: false
    };
    componentDidMount() {
        store.clearValidation();
    }
    componentWillUnmount() {
        store.clearStore();
    }
    protocolOnChange = (checked: boolean, value: string):void => {
        this.setState({protocolCheck: !this.state.protocolCheck});
        store.protocolCheck = checked;
    }
    render() {
        return (
            <div className='register-form'>
                <V.Form className='register-form-wrapper' store={store}>
                    <div className='register-form-label'>
                        <FieldSet className='register-form-fieldSet' size='large' cols={1}>
                            <FormGroup title='公司'>
                                <V.Input field='registerForm.companyName' />
                            </FormGroup>
                            <FormGroup title='登录名'>
                                <V.Input field='registerForm.loginName' />
                            </FormGroup>
                            <FormGroup className='phone-group' title='手机号' layout='vertical'>
                                <div>
                                    <V.Select
                                        className='phone-select'
                                        field='registerForm.areaCode'
                                        options={mainStore.areaCodeOptions}
                                        autoSelect={true}
                                        allowEmpty={false}
                                        tetherable={true}
                                    />
                                    <V.Input field='registerForm.phoneNum' className='phone-input' />
                                </div>
                            </FormGroup>
                            <FormGroup className='code-group' title='验证码' layout='vertical'>
                                <V.Input className='code-input' field='registerForm.verificationCode' />
                                <Button
                                    className={store.isSendCode ? 'register-code-countdown' : 'register-code'}
                                    type='primary'
                                    disabled={store.isSendCode}
                                    onClick={store.toSendCode}>
                                    {store.isSendCode ? store.countdown + 's' : store.sendCodeTip}
                                </Button>
                            </FormGroup>
                        </FieldSet>
                    </div>
                    <div className='chooseProtocol'>
                        <Checkbox field='registerForm.chooseProtocol' value="chooseProtocol" checked={this.state.protocolCheck} onChange={this.protocolOnChange}>
                            已阅读，同意<a href={window.location.origin+'/secret/GaiaAttendanceServiceAgreement.pdf'} target="_blank">《盖雅考勤服务协议》</a><a href={window.location.origin+'/secret/GaiaPrivacyPolicy.pdf'} target="_blank">《盖雅隐私权政策》</a>
                        </Checkbox>
                    </div>
                    <div className='register-form-button' onClick={store.submit}>
                        注册
                    </div>
                    <div className='back' onClick={mainStore.toRegister}>
                        返回
                    </div>
                </V.Form>
                <div className="recordNo">
                    <span>Copyright 2010-2019GaiaWorks Corporation，All Rights Reserved 盖雅工场版权所有 | </span><a href='http://www.miitbeian.gov.cn'>苏ICP备12047504号-3</a>
                </div>
            </div>
        );
    }
}
